<template>
  <div class="modal u-wrapper-panel u-pad-y-xl" :class="content.sectionHandle === 'sbsVideo' ? 'u-flex u-center u-middle' : ''">
    <div class="modal__overlay u-wrapper-panel u-bg-black" @click="onClose"></div>
    <div class="modal__panel u-relative u-w8of12 u-w11of12--sm" :class="content.sectionHandle === 'sbsVideo' ? 'u-box-16by9' : ' u-full-height'">
      <div class="modal__panel u-wrapper-panel">
        <div ref="wrapper" class="modal__panel__content u-bg-grey u-full-height u-full-width u-overflow-hidden u-relative">
          <iframe v-if="content.sectionHandle === 'sbsPdf' && isEnterAnimationOver && iframeWidth !== 0" :src="content.sbsPdfUrl" :width="iframeWidth" :height="iframeHeight" :title="content.title" class="modal__panel__content__iframe u-wrapper-panel"></iframe>
          <template v-if="content.sectionHandle === 'sbsVideo' && isEnterAnimationOver">
            <video-player
              v-if="content.sbsVideo.length"
              :src="content.sbsVideo[0].url"
              :subtitles="content.sbsSubtitles.length ? content.sbsSubtitles[0].url : ''"
              :fill="true"
            />
            <youtube-player v-else :id="content.sbsIdVimeo" :isControls="true" />
          </template>
          <app-article v-if="content.sectionHandle === 'sbsArticle'" :content="content" :is-read-mode="true"></app-article>
        </div>
      </div>
      <button class="modal__btn-close t-button--simple u-absolute u-bg-black" @click="onClose">
        <img src="/images/cross.svg" alt="" class="modal__btn-close__ico u-absolute u-w4of12">
      </button>
    </div>
  </div>
</template>

<script>
import AppArticle from '@/components/common/AppArticle'
import VideoPlayer from '@/components/common/VideoPlayer'
import YoutubePlayer from '@/components/common/YoutubePlayer'

export default {
  components:
  {
    AppArticle,
    VideoPlayer,
    YoutubePlayer
  },

  props: {
    content: {
      type: Object,
      default: null
    }
  },

  data()
  {
    return {
      isEnterAnimationOver: false,
      iframeWidth: 0,
      iframeHeight: 0
    }
  },

  mounted() {
    setTimeout(() =>
    {
      this.isEnterAnimationOver = true
      requestAnimationFrame(this.onResize)
    }, 250)
  },

  methods:
  {
    onClose() {
      this.$emit('modal:close')
    },

    onResize () {
      if (this.$refs.wrapper) {
        console.log('resize', this.$refs.wrapper.offsetWidth, this.$refs.wrapper.offsetHeight)
        this.iframeWidth = this.$refs.wrapper.offsetWidth
        this.iframeHeight = this.$refs.wrapper.offsetHeight
      }
    }
  }
}
</script>

<style lang="stylus">
@import '~@/styles/settings/mixins/viewport-sizer'
@import '~@/styles/settings/variables'
@import '~@/styles/settings/easings'

  .modal
    z-index 2

  .modal__overlay
    opacity .8
    transform translateZ(0)
    transition opacity .4s
    
    .modal-enter &,
    .modal-leave-to &
      opacity 0
      
    .modal-leave-to &
      transition-delay .2s
    
  .modal__panel
    margin auto
    padding 5px
    box-shadow 0px 4px 20px rgba(255, 255, 255, 0.25)
    background linear-gradient(90deg, #6BE489 0%, #54BCF1 100%)
    transform translateY(0) translateZ(0)
    transition transform .6s ease-out-quint, opacity .4s

    .modal-enter &,
    .modal-leave-to &
      opacity 0
      transform translateY(50px) translateZ(0)
      
    .modal-leave-to &
      transform translateY(-25px) translateZ(0)
      
    .modal-enter-active & {
      transition-delay .2s, .2s
    }
    
  .modal__panel
    border-radius 22px
  
  .modal__panel__content
    border-radius 22px
    overflow hidden
    
  .modal__btn-close
    width 40px
    height 40px
    border-radius 50%
    
    left 50%
    top -20px
    
    box-shadow 0px 4.06667px 20.3333px rgba(255, 255, 255, 0.15)
    transform translateX(-50%)
    
  .modal__btn-close__ico
    top 50%
    left 50%
    transform translate(-50%, -50%)
    
</style>